var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccordionArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4838_8787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.039 38.842C15.2889 38.842 11.623 37.73 8.50483 35.6465C5.38671 33.5631 2.95643 30.6018 1.52132 27.1371C0.0862083 23.6724 -0.289284 19.86 0.442329 16.1819C1.17394 12.5039 2.9798 9.12534 5.63155 6.4736C8.28329 3.82185 11.6618 2.01599 15.3399 1.28438C19.018 0.552765 22.8304 0.928256 26.2951 2.36337C29.7597 3.79848 32.721 6.22876 34.8045 9.34688C36.888 12.465 38 16.1309 38 19.881C38 24.9098 36.0023 29.7326 32.4465 33.2885C28.8906 36.8444 24.0678 38.842 19.039 38.842Z",
    fill: "#413482"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.54 16.7611L19.04 23.2611L25.54 16.7611",
    stroke: "white",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4838_8787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.922,
    height: 37.921,
    fill: "white",
    transform: "translate(0.078125 0.921017)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionArrow);
export default __webpack_public_path__ + "static/media/accordion_arrow.82a7120d0ec3b155a90be0a368304e26.svg";
export { ForwardRef as ReactComponent };